import React from "react";

function Tab({ label, render, className, categoryId }) {
  const Component = render;
  return <Component label={label} className={className} categoryId={categoryId} />;
}

export default Tab;
